import React from "react";
import Calculadora from "../../components/CalculadoraV1/CalculadoraV1";
 
import "./CalculadoraV1.css";

function CalculadoraV1() {
  return (
    <section className="sectionHome">         
      <div className="main-content">        
        <div className="area-calculadora"> 
          <div className="div-calculadora">
            <Calculadora />            
          </div>
        </div>         
      </div>
      
    </section>        
  );
}

export default CalculadoraV1;
